import { render, staticRenderFns } from "./UnitSettings.vue?vue&type=template&id=baf8fd06&scoped=true&"
import script from "./UnitSettings.vue?vue&type=script&lang=js&"
export * from "./UnitSettings.vue?vue&type=script&lang=js&"
import style0 from "./UnitSettings.vue?vue&type=style&index=0&id=baf8fd06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf8fd06",
  null
  
)

export default component.exports